import comp from "./RubricTable";
export default comp;
